/**
 * @generated SignedSource<<fb4b73f814dd2ee809435aa25851b2a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "HeaderWithSimpleMenu_navigationItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_navigationItems"
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "57733a19c113f6e5fd772f224c6aaaf4";

module.exports = node;
